import React from "react";

class LeadForm extends React.Component {
    render () {
        return (
            <React.Fragment>
                {/* <input></input> */}
                <form 
                    className="v-leadform"
                    action="https://app.us5.list-manage.com/subscribe/post?u=22259d287367d47e97d6ebe24&amp;id=e913f35af6"
                    method="post"
                    target="_blank" >
                    <label
                        htmlFor="email" >
                        E-Mail
                    </label>
                    <input
                        type="email"
                        id="email"
                        placeholder={this.props.email}
                        name="EMAIL"
                        required/>
                    <button
                        type="submit"
                        name="subscribe" >
                        {this.props.cta}
                    </button>
                </form>
            </React.Fragment>
        );
    }
}

export default LeadForm